import { render, staticRenderFns } from "./SerializedData.vue?vue&type=template&id=63ab6499"
import script from "./SerializedData.vue?vue&type=script&lang=ts"
export * from "./SerializedData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports